module.exports = __webpack_public_path__ + "img/allow_camera.d987450b.png";